import AppBar from '@mui/material/AppBar'
import { styled, alpha, keyframes } from '@mui/material/styles'
import Toolbar from '@mui/material/Toolbar'

export const RootStyle = styled(AppBar)(({ theme }) => ({
   boxShadow: 'none',
   position: 'sticky',
   backdropFilter: 'blur(6px)',
   WebkitBackdropFilter: 'blur(6px)',
   backgroundColor: alpha(theme.palette.background.default, 0.72),
   padding: '20px 0',
   [theme.breakpoints.up('lg')]: {
      width: '100%',
   },
}))

export const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
   minHeight: 64,
   [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 5),
   },
}))

export const StyledLogo = styled('img')(({ theme }) => ({
   display: 'block',
   maxHeight: theme.sizes.headerSm,
   maxWidth: 120,
   [theme.breakpoints.up('lg')]: {
      maxWidth: 210,
   },
}))

const underlinePop = keyframes`
  0% {
    transform: translateX(-50%) scaleX(0);
  }
  60% {
    transform: translateX(-50%) scaleX(1.3);
  }
  100% {
    transform: translateX(-50%) scaleX(1);
  }
`

export const StyledDemoLink = styled('a')({
   textDecoration: 'none',
   position: 'relative',
   textAlign: 'center',
   width: '100%',
   color: 'black',
   minWidth: 'fit-content',
   fontSize: '15px',
   fontWeight: 'normal',
   paddingBottom: '0',

   '&::after': {
      content: '""',
      position: 'absolute',
      left: '50%',
      bottom: '-5px',
      height: '5px',
      width: '100%',
      backgroundColor: '#ff5b45',
      borderRadius: '3px',
      transform: 'translateX(-50%) scaleX(0)',
      transformOrigin: 'center',
      transition: 'transform 0.3s ease',
   },

   '&:hover': {
      cursor: 'pointer',
   },

   '&:hover::after': {
      animation: `${underlinePop} 0.5s forwards ease`,
   },
})
